var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#E3E9F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2877 19.0012H5.71228C5.31891 19.0012 5 18.6778 5 18.2789C5 17.88 5.31891 17.5566 5.71228 17.5566H18.2877C18.6811 17.5566 19 17.88 19 18.2789C19 18.6778 18.6811 19.0012 18.2877 19.0012Z",
    fill: "#052f35 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 16.4733C11.607 16.4733 11.2881 16.1499 11.2881 15.751V5.72227C11.2881 5.32338 11.607 5 12.0004 5C12.3937 5 12.7126 5.32338 12.7126 5.72227V15.751C12.7126 16.1499 12.3937 16.4733 12.0004 16.4733Z",
    fill: "#052f35 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 16.6678L7.435 13.0522C7.12493 12.8067 7.06997 12.3528 7.31214 12.0384C7.55437 11.724 8.00197 11.6683 8.31194 11.9138L11.9998 14.8349L15.6876 11.9138C15.9976 11.6683 16.4452 11.724 16.6874 12.0384C16.9296 12.3528 16.8746 12.8067 16.5646 13.0522L11.9998 16.6678Z",
    fill: "#052f35 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.7625e05f.svg";
export { ForwardRef as ReactComponent };